import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);
import cart from './modules/cart'
import login from './modules/login'
import subject from './modules/subject'
import {CHANGE_SIDEBAR_SHOW} from "@constants/mutation-type";
import course from "./modules/course";
import courseLiveOnline from "./modules/course-live-online"
import {DISPATCH_INIT_USER_INFO} from "@constants/action-type/login-action-type";
import {COMMIT_SET_USER_INFO_PROMISE} from "@constants/mutation-type/login-mutation-type";
import {showWarning} from "@utils/msg";
import chatRoom from './modules/chat-room';

const store = new Vuex.Store({
    state: {
        searchKeyword: '',
        isMobile: false,
        showSidebar: false
    },
    mutations: {
        changeSearchKeyword(state, payload) {
            if (payload.searchKeyword !== null && payload.searchKeyword !== undefined)
                state.searchKeyword = payload.searchKeyword
        },
        setBrowser(state, payload) {
            state.isMobile = payload.isMobile
            state.isMobileScreen = payload.isMobileScreen
        },
        [CHANGE_SIDEBAR_SHOW](state, payload) {
            state.showSidebar = payload.showSidebar
        }
    },
    actions: {
        getBrowser({commit}) {
            const browser = {
                versions: function () {
                    // eslint-disable-next-line no-unused-vars
                    var u = navigator.userAgent, app = navigator.appVersion;
                    return {     //移动终端浏览器版本信息
                        trident: u.indexOf('Trident') > -1, //IE内核
                        presto: u.indexOf('Presto') > -1, //opera内核
                        webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
                        gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
                        mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
                        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
                        android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或uc浏览器
                        iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
                        iPad: u.indexOf('iPad') > -1, //是否iPad
                        webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
                    };
                }(),
                language: (navigator.browserLanguage || navigator.language).toLowerCase(),
            };
            //判断是否为IE内核
            if (browser.versions.trident) {
                showWarning("建议", "IE浏览器可能带来较差体验，建议用现代浏览器浏览或切换为极速模式！", 0)
            }

            // 获取一下屏幕的宽度
            const width = window.innerWidth;
            commit({
                type: 'setBrowser',
                isMobile: browser.versions.mobile,
                isMobileScreen: width < 992
            })

        }
    },
    modules: {
        cart,
        login,
        subject,
        course,
        courseLiveOnline,
        chatRoom
    }
});

const userInfoPromise = store.dispatch(DISPATCH_INIT_USER_INFO);
store.commit(COMMIT_SET_USER_INFO_PROMISE, {userInfoPromise});

export default store;
